<template lang="pug">
  div.mapzoom
    div.mapzoom__selector
      //- LayersSelect
        template(v-for="(option, index) in zoomOptions")
          ods-button(:slot="'option'+index" type="text" size="small" @click="zoomToScale(option.value)") {{ option.label }}
    div.mapzoom__controllers
      ods-button(icon="ods-icon-minus" plain @click="zoomOut()")
      ods-button(icon="ods-icon-plus" plain @click="zoomIn()")
    div.mapzoom__controllers
      ods-button(plain @click="zoom3D()")
        ods-icon(name="ico-2d" size="12" v-if="!z3D")
        ods-icon(name="ico-3d" size="12" v-else)
      ods-button(plain size="small" @click="home()")
        ods-icon(name="home" size="16")
</template>

<script>

import LayersSelect from '@/components/LayersSelect'

export default {
  name: 'ParksAndGardensDashboard',
  data () {
    return {
      zoomOptionSelect: '150',
      z3D: true,
      zoomOptions: [
        {
          value: '50',
          label: 'Distrito'
        },
        {
          value: '150',
          label: 'Municipio'
        }
      ]
    }
  },
  methods: {
    zoomIn () {
      document.getElementById('dataIframe').contentWindow.zoomIn()
    },
    zoomOut () {
      document.getElementById('dataIframe').contentWindow.zoomOut()
    },
    home () {
      document.getElementById('dataIframe').contentWindow.homeButton()
    },
    zoom3D () {
      this.$store.commit('UPDATEBTN3D')
      this.z3D = this.$store.state.globales.btn3D
      // document.getElementById('dataIframe').contentWindow.activarDesactivarCapas3D(this.z3D)

      // Function that controls the events when 3D/2D buttom is pushed
      document
        .getElementById('dataIframe')
        .contentWindow.tiltCameraEffect(this.z3D)

      // Function that controls the visualization of 3D layers
      document
        .getElementById('dataIframe')
        .contentWindow.show3dLayers(this.z3D)
    },
    zoomToScale (scale) {
      this.$store.dispatch('zoomToScale', scale)
    }
  },
  components: {
    LayersSelect
  }
}

</script>

<style lang="scss" scoped>

.mapzoom {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 81px;
  height: auto;
  opacity: 1;
  transition: opacity 0.5s;
  &__selector {
    position: relative;
    margin: 0;
    padding: 0;
    + .mapzoom__controllers {
      margin-top: 8px;
      margin-bottom: 8px;
    }
  }
  &__controllers {
    position: relative;
    background-color: $--color-white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    display: flex;
    &::after {
      content: "";
      display: block;
      position: absolute;
      margin: 10px 0;
      left: 40px;
      /* left: 6px; */
      width: 1px;
      height: 16px;
      background-color: $--color-neutral-3;
      pointer-events: none;
    }
    .ods-button {
      margin: 0;
      padding: 0;
      width: 40px;
      height: 36px;
      padding-top: 4px;
      border-radius: 0;
      background-color: $--color-white;
      border-radius: 2px 0 0 2px;
      border: 0;
      cursor: pointer;
      outline: 0;
      &:hover {
        background: $--color-primary;
        color: $--color-white;
      }
      &:focus,
      &:active {
        background: $--color-white;
        color: $--color-primary;
      }
      i {
        margin-left: 0;
      }
      + .ods-button {
        border-radius: 0 2px 2px 0;
        margin-left: 1px;
        box-shadow: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MapZoomParks.vue